export default [
    {
        path: 'pools',
        component: () => import('@/pages/isle/prize/pools')
    },
    {
        path: 'bag',
        component: () => import('@/pages/isle/prize/bag')
    },
    {
        path: 'frag',
        component: () => import('@/pages/isle/prize/frag')
    }
];
